import React from 'react'
import { Link} from "react-router-dom";

export default function HomeHeader() {
  return (
    <>
    <header className="home-header">
        <div className="homelogo"> 
            <Link to={"/"}><img src="/image/home-logo.webp" alt="Logo" /></Link>
        </div>
    
        <div className="header-links"> 
            <a href="tel:+91 9292928787" className='phone-link'><img src="/image/phone.webp" alt="phone" /> +91 929292 8787</a>
            <Link to="https://www.swiftbook.io/inst/#group?groupId=381M25HpcJdio6EBB8BhhWNjE2NzE=&JDRN=Y" target="_blank"  className='book-link'><img src="/image/calender.webp" alt="calender" /> Book My Stay</Link>
        </div>
    </header>
    </>
  )
}
